/**
 * D7: Djay Selection (mascot variant per account)
 * Source: src/mascot/useDjaySelection.ts
 */

import { USE_BACKEND } from '../helpers'

const DJAY_VARIANT_PREFIX = 'meester-djay-variant-'
const DJAY_LONGPRESS_PREFIX = 'meester-djay-longpress-'

export async function getDjayVariant(
  accountId: string | null,
): Promise<string | null> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented')
  }
  try {
    const key = accountId
      ? `${DJAY_VARIANT_PREFIX}${accountId}`
      : `${DJAY_VARIANT_PREFIX}global`
    return localStorage.getItem(key)
  } catch {
    return null
  }
}

export async function saveDjayVariant(
  accountId: string | null,
  variant: string | null,
): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented')
  }
  try {
    const key = accountId
      ? `${DJAY_VARIANT_PREFIX}${accountId}`
      : `${DJAY_VARIANT_PREFIX}global`
    if (!variant || variant === 'default') {
      localStorage.removeItem(key)
    } else {
      localStorage.setItem(key, variant)
    }
  } catch {
    // silent
  }
}

export async function getDjayLongPressDiscovered(
  accountId: string | null,
): Promise<boolean> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented')
  }
  try {
    const key = accountId
      ? `${DJAY_LONGPRESS_PREFIX}${accountId}`
      : `${DJAY_LONGPRESS_PREFIX}global`
    return localStorage.getItem(key) === 'true'
  } catch {
    return false
  }
}

export async function saveDjayLongPressDiscovered(
  accountId: string | null,
  discovered: boolean,
): Promise<void> {
  if (USE_BACKEND) {
    throw new Error('Backend not implemented')
  }
  try {
    const key = accountId
      ? `${DJAY_LONGPRESS_PREFIX}${accountId}`
      : `${DJAY_LONGPRESS_PREFIX}global`
    localStorage.setItem(key, String(discovered))
  } catch {
    // silent
  }
}
